module.exports = "/_next/static/images/ff4f83b855bc561786cd9618bfd97ae9-email-verification-success.jpg";